import { Routes } from '@angular/router';

import { ExtendedTableComponent } from './extendedtable/extendedtable.component';
import { RegularTableComponent } from './regulartable/regulartable.component';
import { DataTableComponent } from './datatable.net/datatable.component';
import { ListuserComponent } from './listuser/listuser.component';
import { ListebayitemsComponent } from './listebayitems/listebayitems.component';
import { ListlogsComponent } from './listlogs/listlogs.component';
import { ListpersonalComponent } from './listpersonal/listpersonal.component';
import { ListcontactformComponent } from './listcontactform/listcontactform.component';
import { ListpagosComponent } from './listpagos/listpagos.component';


import { ListfilesComponent } from './listfiles/listfiles.component';
import { ListfilescompanyComponent } from './listfilescompany/listfilescompany.component';
import { ListshowfilescompanyComponent } from './listfilescompany/listshowfilescompany.component';
import { ListcompanyComponent } from './listcompany/listcompany.component';
import { ListshowfilesComponent } from './listfiles/listshowfiles.component';
import { ListunedainventoryComponent } from './listunedainventory/listunedainventory.component';
import { BaseRouteGuard } from '../shared/guard/base-route-guard';
import { ArchiveComponent } from './archive/archive.component';

export const TablesRoutes: Routes = [
    {
      path: '',
      children: [ {
        path: 'regular',
        component: RegularTableComponent
    }],
    canActivate: [BaseRouteGuard]
    }, {
    path: '',
    children: [ {
      path: 'extended',
      component: ExtendedTableComponent
    }],
    canActivate: [BaseRouteGuard]
    }, {
      path: '',
      children: [ {
        path: 'datatables.net',
        component: DataTableComponent
      }],
      canActivate: [BaseRouteGuard]
    }, {
      path: '',
      children: [ {
        path: 'listuser',
        component: ListuserComponent
        }],
        canActivate: [BaseRouteGuard]
    }, {
      path: '',
      children: [ {
        path: 'listebayitems',
        component: ListebayitemsComponent
        }]
    }, {
      path: '',
      children: [ {
        path: 'listebayitems/:page',
        component: ListebayitemsComponent
        }],
        canActivate: [BaseRouteGuard]
    },{
      path: '',
      children: [ {
        path: 'listlogs',
        component: ListlogsComponent
        }],
        canActivate: [BaseRouteGuard]
    },{
      path: '',
      children: [ {
        path: 'listpersonal',
        component: ListpersonalComponent
        }],
        canActivate: [BaseRouteGuard]
    }, {
      path: '',
      children: [ {
        path: 'listcontactform',
        component: ListcontactformComponent
        }],
        canActivate: [BaseRouteGuard]
    }, {
      path: '',
      children: [ {
        path: 'listpagos',
        component: ListpagosComponent
        }],
        canActivate: [BaseRouteGuard]
    }, {
      path: '',
      children: [ {
        path: 'listfiles',
        component: ListfilesComponent
        }],
        canActivate: [BaseRouteGuard]
    },{
      path: '',
      children: [ {
        path: 'listcompanyfiles',
        component: ListfilescompanyComponent
        }],
        canActivate: [BaseRouteGuard]
    },{
      path: '',
      children: [ {
        path: 'archive',
        component: ArchiveComponent
        }],
        // canActivate: [BaseRouteGuard]
    },{
      path: '',
      children: [ {
        path: 'listcompanies',
        component: ListcompanyComponent
        }],
        canActivate: [BaseRouteGuard]
    }, {
      path: '',
      children: [ {
        path: 'listfiles/:id',
        component: ListshowfilesComponent
        }],
        canActivate: [BaseRouteGuard]
    }, {
      path: '',
      children: [ {
        path: 'listcompanyfiles/:id',
        component: ListshowfilescompanyComponent
        }],
        canActivate: [BaseRouteGuard]
    }, {
      path: '',
      children: [ {
        path: 'listunedainventory',
        component: ListunedainventoryComponent
        }]
    }
];
